import Map from 'scripts/models/base/map';
import ImageGeneric from 'scripts/models/api/image/generic';
import ImageCloudinary from 'scripts/models/api/image/cloudinary';

export default {
    Type: function (obj) {
        let type = obj && obj.type;

        if (type === 'generic') {
            return new ImageGeneric(obj);
        }
        else if (type === 'cloudinary') {
            return new ImageCloudinary(obj);
        }
        else {
            return new Map(obj);
        }
    },
    Value: '*'
};